import { render, staticRenderFns } from "./BlockType25.vue?vue&type=template&id=2b4a029f&scoped=true"
import script from "./BlockType25.vue?vue&type=script&lang=ts"
export * from "./BlockType25.vue?vue&type=script&lang=ts"
import style0 from "./BlockType25.vue?vue&type=style&index=0&id=2b4a029f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a029f",
  null
  
)

export default component.exports